<template>
    <!-- Section: Design Block -->
    <section class="background-radial-gradient overflow-hidden height-100">
        <div class="container px-4 py-5 px-md-5 text-center text-lg-start my-5">
            <div class="row gx-lg-5 align-items-center mb-5">
                <div class="col-md-6 col-lg-7"></div>
                <div class="col-sm-12 col-md-6 col-lg-5 mb-5 mb-lg-0 position-relative">
                    <div class="card bg-glass">
                        <div class="card-body px-4 py-5 px-md-5">

                            <form @submit="login">
                                <!-- Email input -->
                                <div class="form-outline mb-4">
                                    <label class="form-label">Email:</label>
                                    <input type="text" class="form-control" v-model="user.UserName"
                                        placeholder="Enter username or email id" required/>
                                </div>

                                <!-- Password input -->
                                <div class="form-outline mb-4">
                                    <label class="form-label">Password:</label>
                                    <input type="password" class="form-control" v-model="user.password"
                                        placeholder="Enter password" required/>
                                </div>

                                <!-- Submit button -->
                                <button type="submit" class="btn btn-primary btn-block">
                                    Login
                                </button>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {
    name: "LoginComponent",
    data() {
        return {
            user: {
                UserName: '',
                Email: "",
                password: ""
            }
        }
    },
    methods: {
        loginhome() {
            this.$router.push()
        },
        async login() {
             event.preventDefault()
             await this.$store.dispatch("userLogin", this.user)
            if (this.$store.state.isLoggedIn)
                this.$router.push({ path: 'faculty' })
        }
    }
};
</script>
<style scoped>
.background-radial-gradient {
    background-image: url('../assets/nwbackground.jfif');
    background-position: center;
    background-size: cover;
}

.bg-glass {
    background-color: #f5f5f5b0 !important;
    backdrop-filter: saturate(150%) blur(15px);
}

.height-100 {
    height: 100vh !important;
}
</style>